module.exports = __webpack_public_path__ + "static/addressbar-6eb53fcf83421ef3e8180da294d9b472.png";